import { useLocationQuery } from '@web/helpers/hooks';
import { useLocation } from 'react-router-dom';

export const useIsStaff = () => {
  const { pathname: path } = useLocation();
  const query = useLocationQuery();
  return path.startsWith('/staff-timesheets') || query.get('staff') === 'true';
};
